import { ChangeDetectorRef, Component, inject, Input, input, OnInit, TemplateRef, viewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { forkJoin } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { OcJsonSchemaValidatorAjv } from '../../../../../../core/oc-validator/oc-jsonSchemaValidatorAjv.service';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IError } from '@orgacard/login';
import { IMyDate, IMyDateModel, IMyDateRange, IMyOptions } from 'gramli-angular-mydatepicker';
import { cloneDeep, isNil, orderBy } from 'lodash';
import moment from 'moment';

import { AppService } from '../../../../../../app.service';
import { CoreService } from '../../../../../../core/core.service';
import { EnvironmentService } from '../../../../../../core/environment.service';
import { ocValidator } from '../../../../../../core/oc-validator/oc.validator';
import { ModalService } from '../../../../../../core/services/modal.service';
import { UtilityHelperService } from '../../../../../../core/utility-helper.service';
import { LoadingOverlayService } from '../../../../../../loading-overlay/loading-overlay.service';
import { AddressesComponent } from '../../../../../shared/addresses/addresses.component';
import { IAddressDisplay, IHoliday, IOrderFrequency, ITimepickerModel, IWeek, LockedType, OCDay, SystemMethod } from '../../../../../shared/models/basic.model';
import { ArchiveType } from '../../../../shared/models/archive.enum';
import {
    ICustomerAddress,
    ISupplierContractCostcenterCustomer,
    ISupplierCustomerDetails,
    ISupplierDeliveryTermDays,
    ISupplierDeliveryTermHolidays,
} from '../../../../shared/models/supplier.model';
import { SupplierService } from '../../../../shared/services/supplier.service';

@UntilDestroy()
@Component({
    selector: 'app-deliveryterms',
    templateUrl: './deliveryterms.component.html',
    styleUrls: ['./deliveryterms.component.scss'],
    standalone: false,
})
export class DeliverytermsComponent implements OnInit {
    private readonly utilityHelperService = inject(UtilityHelperService);
    private formBuilder = inject(UntypedFormBuilder);
    coreService = inject(CoreService);
    private appService = inject(AppService);
    environmentService = inject(EnvironmentService);
    ocJsonSchemaValidatorAjv = inject(OcJsonSchemaValidatorAjv);
    supplierService = inject(SupplierService);
    private modalService = inject(ModalService);
    private cdr = inject(ChangeDetectorRef);
    loadingOverlayService = inject(LoadingOverlayService);

    public readonly deliveryTermsModal = viewChild<TemplateRef<any>>('deliveryConditionModal');
    public readonly orderdaysModal = viewChild<TemplateRef<any>>('orderdaysModal');
    public readonly deliverydaysCustomerModal = viewChild<TemplateRef<any>>('deliverydaysCustomerModal');
    public readonly deliveryTermHolidaysModal = viewChild<TemplateRef<any>>('deliveryTermHolidaysModal');
    public readonly archiveElementModal = viewChild<TemplateRef<any>>('archiveElementModal');
    public readonly selectNewFavoriteHintModal = viewChild<TemplateRef<any>>('selectNewFavoriteHintModal');
    public readonly setValidTillHintModal = viewChild<TemplateRef<any>>('setValidTillHintModal');
    public readonly selectNewFavoriteAddressHintModal = viewChild<TemplateRef<any>>('selectNewFavoriteAddressHintModal');
    public readonly addressesComponent = viewChild(AddressesComponent);

    @Input() public supplierContractCostcenterCustomer: ISupplierContractCostcenterCustomer = undefined;
    public readonly indexSupplierContractCostcenters = input<number>(undefined);
    public readonly showButtons = input<boolean>(true);
    public readonly showCustomerDiv = input<boolean>(true);
    public readonly showAddresses = input<boolean>(true);
    public readonly costcenterAddresses = input<IAddressDisplay[]>(undefined);

    public deliverytermsAddressTitle: string = this.coreService.getMsgkey('mws.customerdeliveryadresses', undefined);

    public deliverytermsForm: UntypedFormGroup;
    public deliveryConditionModalForm: UntypedFormGroup;
    public orderdaysModalForm: UntypedFormGroup;
    public deliverydaysCustomerModalForm: UntypedFormGroup;
    public deliveryTermHolidaysModalForm: UntypedFormGroup;
    public holidayList: IHoliday[] = [];

    public dateModelFrom: IMyDateModel = { isRange: false, singleDate: undefined, dateRange: {} }; // Keine Datum Vorbelegung !!!
    public dateModelTill: IMyDateModel = { isRange: false, singleDate: undefined, dateRange: {} }; // Keine Datum Vorbelegung !!!
    // dateFromForm: FormGroup;
    // dateTillForm: FormGroup;
    public dateFromFormDateValid: boolean = false;

    public tempElementId: number;

    public archiveElementHeader: string;
    public archiveElementText: string;
    public archiveElementType: ArchiveType;

    private emptyTime: ITimepickerModel = { hour: 0, minute: 0, second: 0 };
    private emptyTimeOrder: ITimepickerModel = { hour: 23, minute: 59, second: 0 };
    private emptyTimeDelivery: ITimepickerModel = { hour: 0, minute: 1, second: 0 };
    public readonly orderFormType: string = 'ORDER';
    public readonly deliveryFormType: string = 'DELIVERY';
    public setValidTillHintModalVersion: string = '';

    public systemMethod: SystemMethod;
    public systemMethodEnum = SystemMethod;

    // Lieferbedingungen
    public displayedColumnsConditions: string[] = ['datefrom', 'datetill', 'desc', 'value', 'unit', 'buttons'];
    // Liefertage
    public displayedColumnsDeliverydays: string[] = ['datefrom', 'datetill', 'day_0', 'day_1', 'day_2', 'day_3', 'day_4', 'day_5', 'day_6', 'buttons'];
    // Bestelltage
    public displayedColumnsOrderdays: string[] = [
        'datefrom',
        'datetill',
        'day_0',
        'day_1',
        'day_2',
        'day_3',
        'day_4',
        'day_5',
        'day_6',
        'orderDetail',
        'orderLeadTimeDays',
        'buttons',
    ];

    // Feiertage
    public displayedColumnsHolidays: string[] = ['date', 'time', 'desc', 'buttons'];

    public nextOrderday: string = '';

    public addresses: IAddressDisplay[];

    supplierDeliveryTermOrderdays: ISupplierDeliveryTermDays[];
    supplierDeliveryTermDeliverdays: ISupplierDeliveryTermDays[];
    // Liefertage
    deliverdaysTableModel: IWeek[] = [];
    // Bestelltage
    orderdaysTableModel: IOrderFrequency[] = [];

    public get dateTillFormDeliverydaysCustomerModalForm(): UntypedFormGroup {
        return this.deliverydaysCustomerModalForm.get('dateTillForm') as UntypedFormGroup;
    }

    public get dateFromFormDeliverydaysCustomerModalForm(): UntypedFormGroup {
        return this.deliverydaysCustomerModalForm.get('dateFromForm') as UntypedFormGroup;
    }

    public get dateTillFormOrderdaysModalForm(): UntypedFormGroup {
        return this.orderdaysModalForm.get('dateTillForm') as UntypedFormGroup;
    }

    public get dateFromFormOrderdaysModalForm(): UntypedFormGroup {
        return this.orderdaysModalForm.get('dateFromForm') as UntypedFormGroup;
    }

    public get orderdaysDayforms(): UntypedFormArray {
        return this.orderdaysModalForm.get('dayforms') as UntypedFormArray;
    }

    public get deliverydaysDayforms(): UntypedFormArray {
        return this.deliverydaysCustomerModalForm.get('dayforms') as UntypedFormArray;
    }

    ngOnInit() {
        this.setNextOrderday();
        this.init();
        this.initDeliverytermsForm();
    }

    // convenience getter for easy access to form fields
    get basedataf() {
        return this.deliverytermsForm.controls;
    }

    init() {
        this.loadCustomerDetailsByCustomerId();
        // this.loadHolidays();
    }

    // loadHolidays() {
    //     this.coreService
    //         .getHolidays(LockedType.NOTLOCKED)
    //         .pipe(take(1))
    //         .subscribe(
    //             (data: any) => {},
    //             (err: IError) => {
    //                 this.utilityHelperService.handleComponentError(err);
    //             },
    //         );
    // }

    loadCustomerDetailsByCustomerId() {
        // console.log('loadCustomerDetailsByCustomerId: ' + this.supplierContractCostcenterCustomer.id);
        this.loadingOverlayService.startLoading();

        // this.supplierService.getCustomerDetailsByCustomerId(this.supplierContractCostcenterCustomer.id).subscribe((data: any) => {
        this.supplierService
            .getCustomerDetailsByCustomerId(this.supplierContractCostcenterCustomer.supplierCustomer.id)
            .pipe(take(1))
            .subscribe(
                (supplierCustomerDetails: ISupplierCustomerDetails) => {
                    if (this.environmentService.appSettings.showLog)
                        console.log(
                            new Date() +
                                ': ' +
                                'conditions.component.ts - loadCustomerDetailsByCustomerId ---> RESPONSE supplierCustomerDetails: ' +
                                JSON.stringify(supplierCustomerDetails),
                        );
                    //
                    this.supplierDeliveryTermOrderdays = cloneDeep(supplierCustomerDetails.supplierDeliveryTermOrderdays);
                    this.supplierDeliveryTermDeliverdays = cloneDeep(supplierCustomerDetails.supplierDeliveryTermDeliverdays);
                    this.mapWeekdaysLocalized();
                    this.mapDeliverydayTableModel();
                    this.mapOrderdayTableModel();
                    this.sortDeliveryDaysCollections();
                    this.sortOrderDaysCollections();
                    this.fillAddresses();
                    // NOTE: Strukturumstellung supplierDeliveryTerm ist weggefallen
                    // this.supplierService.getSupplierDeliveryTerms().subscribe(response => {
                    //     // load supplierDeliveryTerms
                    //
                    // }, (err: IError) => {
                    //     this.utilityHelperService.handleComponentError(err);
                    // });
                    this.loadingOverlayService.stopLoading();
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    archiveCustomerOpenModal(supplierContractCostcenterCustomerId: number) {
        this.tempElementId = supplierContractCostcenterCustomerId;
        this.archiveElementHeader = 'mws.deleteCustomerHeadline';
        this.archiveElementText = 'mws.deleteCustomerText';
        this.archiveElementType = ArchiveType.SUPPLIERCUSTOMER;
        const options: NgbModalOptions = { centered: false, backdrop: 'static', size: 'lg' };
        this.modalService.openModal(this.archiveElementModal(), options);
    }

    showSelectNewFavoriteHintModal() {
        const options: NgbModalOptions = { centered: false, backdrop: 'static', size: 'lg' };
        this.modalService.openModal(this.selectNewFavoriteHintModal(), options);
    }

    checkArchiveCustomer(supplierContractCostcenterCustomerId: number) {
        const customerToArchive = this.supplierService.supplierContractDetail.supplierContractCostcenters[
            this.indexSupplierContractCostcenters()
        ].supplierContractCostcenterCustomers.find((sCCC) => sCCC.id === supplierContractCostcenterCustomerId);

        // 2024-07-25 SR: if (!customerToArchive.supplierCustomer.isFavorite) {
        // 2024-11-05 SR: Verstehe diese Abfrage nicht!?
        // if (this.supplierContractCostcenterCustomer.isFavorite) {
        //     this.archiveCustomerOpenModal(supplierContractCostcenterCustomerId);
        //
        //     return;
        // }
        // 2024-07-25 SR: Neu, wenn Favorit, dann muss erst ein anderer Kunde zum Favoriten auserwählt werden!
        if (customerToArchive.isFavorite) {
            this.showSelectNewFavoriteHintModal();

            return;
        }

        // http://gitlab.orgacard.local:8090/angular/apps/wawi/-/issues/798
        // 2024-11-05 SR: Verstehe diese Abfrage nicht!?
        // 2024-11-05 SR: siehe: http://gitlab.orgacard.local:8090/angular/apps/wawi/-/issues/874
        // 2024-11-05 SR: => keine Löschung von Kunden mehr möglich, wenn es mehr als zwei Kunden gibt?
        // if (this.supplierService.supplierContractDetail.supplierContractCostcenters[
        //     this.indexSupplierContractCostcenters
        //     ].supplierContractCostcenterCustomers.length > 2) {
        //     this.showSelectNewFavoriteHintModal();
        //
        //     return;
        // }

        this.archiveCustomerOpenModal(supplierContractCostcenterCustomerId);
    }

    archiveCustomer() {
        // TODO:
        console.log('TODO: deliveryterm.component - archiveCustomer');
        console.log('TODO: deliveryterm.component - archiveCustomer');
        console.log('TODO: deliveryterm.component - archiveCustomer');
    }

    cancelCustomer() {
        // TODO:
        console.log('TODO: deliveryterm.component - cancelCustomer');
        console.log('TODO: deliveryterm.component - cancelCustomer');
        console.log('TODO: deliveryterm.component - cancelCustomer');
    }

    public onSaveCustomer() {
        const tempCustomer: ISupplierContractCostcenterCustomer = this.fillSupplierContractCostcenterCustomerObj();
        this.saveCustomer(tempCustomer);
    }

    private saveCustomer(sCCC: ISupplierContractCostcenterCustomer, markAsUntouched = true) {
        this.supplierService
            .saveSupplierCostcenterCustomer(sCCC)
            .pipe(take(1))
            .subscribe(
                (supplierContractCostcenterCustomer) => {
                    // HINWEIS: HIER DEN customerName aktualisieren! NICHT DAS GANZE OBJEKT ZUWEISEN !!!
                    // HINWEIS: funktioniert NICHT anders als so! Ansonsten reloaded die ChangeDetection die Accordions und macht die zu
                    // MUSS SO BLEIBEN
                    const i = this.supplierService.supplierContractDetail.supplierContractCostcenters[
                        this.indexSupplierContractCostcenters()
                    ].supplierContractCostcenterCustomers.findIndex((sccc) => sccc.id === supplierContractCostcenterCustomer.id);
                    this.supplierService.supplierContractDetail.supplierContractCostcenters[
                        this.indexSupplierContractCostcenters()
                    ].supplierContractCostcenterCustomers[i].supplierCustomer.customerName = supplierContractCostcenterCustomer.supplierCustomer.customerName;
                    //
                    // update isFavorite flag
                    // SR 2024-07-25: this.supplierService.supplierContractDetail.supplierContractCostcenters[this.indexSupplierContractCostcenters].supplierContractCostcenterCustomers[i].supplierCustomer.isFavorite = supplierContractCostcenterCustomer.supplierCustomer.isFavorite;
                    this.supplierService.supplierContractDetail.supplierContractCostcenters[
                        this.indexSupplierContractCostcenters()
                    ].supplierContractCostcenterCustomers[i].isFavorite = supplierContractCostcenterCustomer.isFavorite;

                    if (supplierContractCostcenterCustomer.id === sCCC.id) {
                        if (markAsUntouched) {
                            this.deliverytermsForm.get('changed').markAsUntouched();
                        }
                        this.loadingOverlayService.stopLoading();
                    }
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    fillSupplierContractCostcenterCustomerObj(): ISupplierContractCostcenterCustomer {
        return {
            id: this.supplierContractCostcenterCustomer.id,
            supplierCustomer: {
                id: this.supplierContractCostcenterCustomer.supplierCustomer.id,
                supplierId: this.supplierService.supplierId,
                customerName: this.deliverytermsForm.get('customerName').value,
                customerNumber: this.deliverytermsForm.get('customerNumber').value,
                currencyId: this.deliverytermsForm.get('currencyId').value,
                // isFavorite: false, // this.supplierContractCostcenterCustomer.supplierCustomer.isFavorite,
            },
            firstorderdate: this.deliverytermsForm.get('firstorderdate').value,
            minimumOrderValue: this.deliverytermsForm.get('minimumOrderValue').value,
            supplierContractCostcenterId: this.supplierContractCostcenterCustomer.supplierContractCostcenterId,
            supplierContractId: this.supplierService.supplierContract.id,
            isFavorite: this.supplierContractCostcenterCustomer.isFavorite,
        };
    }

    fillAddresses() {
        this.addresses = [];
        this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.forEach((sca) => {
            sca.address._isFavorite = sca.isFavorite;
            this.addresses.push(sca.address);
        });
        const addressesComponent = this.addressesComponent();
        if (addressesComponent) {
            addressesComponent.fillData(this.addresses);
        }
    }

    initDeliverytermsForm() {
        // disabled: !this.coreService.checkAbility('update', 'suppliercustomer.customernumber'),
        // #870 Änderung der Lieferanten KundenNumme / LieferantenArtikel-Import via Stage
        this.deliverytermsForm = this.formBuilder.group({
            customerNumber: [
                {
                    value: this.supplierContractCostcenterCustomer.supplierCustomer.customerNumber,
                    disabled: true,
                },
                [ocValidator(this.ocJsonSchemaValidatorAjv, this.environmentService, 'supplierCustomer', 'customerNumber')],
            ],
            customerName: [
                {
                    value: this.supplierContractCostcenterCustomer.supplierCustomer.customerName,
                    disabled: !this.coreService.checkAbility('update', 'suppliercustomer.customername'),
                },
                [ocValidator(this.ocJsonSchemaValidatorAjv, this.environmentService, 'supplierCustomer', 'customerName')],
            ],
            firstorderdate: new UntypedFormControl(
                {
                    value:
                        this.supplierContractCostcenterCustomer.firstorderdate && this.supplierContractCostcenterCustomer.firstorderdate.length > 0
                            ? moment(this.supplierContractCostcenterCustomer.firstorderdate).locale(this.environmentService.appSettings.locale).format('LT')
                            : '',
                    disabled: true,
                },
                Validators.required,
            ),
            minimumOrderValue: [
                {
                    value: this.supplierContractCostcenterCustomer.minimumOrderValue,
                    disabled: !this.coreService.checkAbility('update', 'suppliercontractcostcentercustomer.minimusordervalue'),
                },
                [ocValidator(this.ocJsonSchemaValidatorAjv, this.environmentService, 'supplierCustomer', 'minimumOrderValue')],
            ],
            currencyId: [
                {
                    value: this.supplierContractCostcenterCustomer.supplierCustomer.currencyId,
                    disabled: true,
                },
            ],
            isFavorite: {
                value: this.supplierContractCostcenterCustomer.isFavorite,
            },
            supplierContractCostcenterId: {
                value: this.supplierContractCostcenterCustomer.supplierContractCostcenterId,
            },
            changed: false,
        });
        this.deliverytermsForm.valueChanges.pipe(untilDestroyed(this)).subscribe((change) => {
            // PRÜFEN OB FORM VALID IST !!! NICHT VIA this.xxxxxxForm.valid
            // PRÜFEN OB FORM VALID IST !!! NICHT VIA this.xxxxxxForm.valid

            const tempCustomer: ISupplierContractCostcenterCustomer = this.fillSupplierContractCostcenterCustomerObj();
            const result = this.ocJsonSchemaValidatorAjv.validateData('supplierCustomer', tempCustomer.supplierCustomer);
            if (!this.deliverytermsForm.get('changed').touched && result.isValid) {
                this.deliverytermsForm.get('changed').markAsTouched();
            } else if (!result.isValid) {
                this.deliverytermsForm.get('changed').markAsUntouched();
            }
        });
    }

    /**
     * BESTELLTAGE
     */
    initOrderdaysModalForm(supplierDeliveryTermDays?: ISupplierDeliveryTermDays) {
        if (supplierDeliveryTermDays !== undefined) {
            this.orderdaysModalForm = this.formBuilder.group({
                id: supplierDeliveryTermDays.id,
                dateFromForm: this.formBuilder.group({
                    date: supplierDeliveryTermDays.validFrom
                        ? {
                              isRange: false,
                              dateFormat: 'dd.mm.yyyy',
                              singleDate: { jsDate: new Date(supplierDeliveryTermDays.validFrom) },
                              dateRange: false,
                          }
                        : this.dateModelFrom,
                    options: supplierDeliveryTermDays.validFrom
                        ? {
                              appendSelectorToBody: true,
                              disableSince: this.coreService.convertToMyDate(moment(0).toDate()),
                          }
                        : {
                              appendSelectorToBody: true,
                              disableUntil: this.coreService.convertToMyDate(moment(new Date()).toDate()),
                              disableDateRanges: this.getDisableDateRangesForDaysFrom(this.orderFormType),
                          },
                }),
                dateTillForm: this.formBuilder.group({
                    date: supplierDeliveryTermDays.validTill
                        ? {
                              isRange: false,
                              dateFormat: 'dd.mm.yyyy',
                              singleDate: { jsDate: new Date(supplierDeliveryTermDays.validTill) },
                          }
                        : {
                              dateRange: false,
                              dateFormat: 'dd.mm.yyyy',
                          },
                    // options: new DatepickerHelper().datePickerOptions
                    // VARIANTE A: wenn dateFrom gefüllt ist, muss es nach dateFrom sein
                    // options: supplierDeliveryTermDays.dateFrom ? {
                    //     disableUntil: this.coreService.convertToMyDate(new Date(supplierDeliveryTermDays.dateFrom))
                    // } : {
                    //     disableUntil: this.coreService.convertToMyDate(new Date())
                    // }
                    // VARIANTE B: Änderungen immer max ab heutigem Tag, hier kann es zu einem NgViewAfterInit Error kommen, wenn der ausgewählte Wert im DISABLED-Bereich liegt

                    // options: {
                    //     disableUntil: this.getDisableUntilDateForDaysTill(supplierDeliveryTermDays),
                    // },
                    options: this.getDateTillFormOptions(this.orderFormType, supplierDeliveryTermDays),
                }),
                rhythm: supplierDeliveryTermDays.isOrderRhythmWeekly ? 1 : 2,
                orderRhythm: [
                    {
                        value: supplierDeliveryTermDays.orderRhythm,
                        disabled: false,
                    }, // !this.coreService.checkAbility('update', 'supplier.description') }),
                    [
                        Validators.pattern('^[0-9]*$'),
                        ocValidator(
                            this.ocJsonSchemaValidatorAjv,
                            this.environmentService,
                            'supplierDeliveryTermDay',
                            'orderRhythm',
                            this.coreService.getMsgkey('mws.all', undefined),
                        ),
                    ],
                ],
                dayforms: this.formBuilder.array([
                    this.formBuilder.group({
                        day: OCDay.MONDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayMon,
                        time: supplierDeliveryTermDays.isWeekdayMon
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeMon)
                            : this.emptyTimeOrder,
                    }),
                    this.formBuilder.group({
                        day: OCDay.TUESDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayTue,
                        time: supplierDeliveryTermDays.isWeekdayTue
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeTue)
                            : this.emptyTimeOrder,
                    }),
                    this.formBuilder.group({
                        day: OCDay.WEDNESDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayWed,
                        time: supplierDeliveryTermDays.isWeekdayWed
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeWed)
                            : this.emptyTimeOrder,
                    }),
                    this.formBuilder.group({
                        day: OCDay.THURSDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayThu,
                        time: supplierDeliveryTermDays.isWeekdayThu
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeThu)
                            : this.emptyTimeOrder,
                    }),
                    this.formBuilder.group({
                        day: OCDay.FRIDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayFri,
                        time: supplierDeliveryTermDays.isWeekdayFri
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeFri)
                            : this.emptyTimeOrder,
                    }),
                    this.formBuilder.group({
                        day: OCDay.SATURDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdaySat,
                        time: supplierDeliveryTermDays.isWeekdaySat
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeSat)
                            : this.emptyTimeOrder,
                    }),
                    this.formBuilder.group({
                        day: OCDay.SUNDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdaySun,
                        time: supplierDeliveryTermDays.isWeekdaySun
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeSun)
                            : this.emptyTimeOrder,
                    }),
                ]),
                orderLeadTimeDays: [supplierDeliveryTermDays.orderLeadTimeDays, [Validators.pattern('^[0-9]*$'), Validators.max(15)]],
                isLast: this.isLastDeliveryTermDays(this.orderFormType, supplierDeliveryTermDays.id),
                changed: false,
            });
        } else {
            this.orderdaysModalForm = this.formBuilder.group({
                id: undefined,
                dateFromForm: this.formBuilder.group({
                    date: [
                        this.dateModelFrom,
                        // isRange: false,
                        // dateFormat: 'dd.mm.yyyy',
                        // singleDate: this.dateModelFrom{jsDate: moment(new Date()).subtract(1, "days").toDate()},
                        // dateRange: false
                    ],
                    options: {
                        appendSelectorToBody: true,
                        dateRange: false,
                        dateFormat: 'dd.mm.yyyy',
                        disableUntil: this.coreService.convertToMyDate(moment(new Date()).toDate()),
                        disableDateRanges: this.getDisableDateRangesForDaysFrom(this.orderFormType),
                    },
                }),
                dateTillForm: this.formBuilder.group({
                    date: [this.dateModelTill],
                    options: this.getDateTillFormOptions(this.orderFormType, {} as ISupplierDeliveryTermDays),
                }),
                rhythm: 1,
                orderRhythm: 1,
                dayforms: this.getEmptyWeekFormArray(this.orderFormType),
                orderLeadTimeDays: [0, [Validators.pattern('^[0-9]*$'), Validators.max(15)]],
                isLast: true,
                changed: false,
            });
        }
        // INIT
        if (supplierDeliveryTermDays !== undefined && supplierDeliveryTermDays.validFrom) {
            this.dateFromFormDateValid = true;
        } else {
            this.dateFromFormDateValid = false;
        }
        // SUBSCRIBE: orderdaysModalForm
        this.orderdaysModalForm.valueChanges.pipe(untilDestroyed(this)).subscribe({
            next: (change) => {
                if (
                    !this.orderdaysModalForm.get('orderLeadTimeDays').errors?.['pattern'] &&
                    !this.orderdaysModalForm.get('orderRhythm').errors?.['pattern'] &&
                    this.dateFromFormDateValid &&
                    this.dayformChoosen(this.orderdaysModalForm) &&
                    (!this.orderdaysModalForm.get('dateTillForm').get('date').value?.singleDate?.jsDate ||
                        this.orderdaysModalForm.get('dateTillForm').get('date').value?.singleDate?.jsDate >
                            this.orderdaysModalForm.get('dateFromForm').get('date').value?.singleDate?.jsDate)
                ) {
                    // TODO
                    // "required": [
                    //     "isDelivery",
                    //     "isOrder",
                    //     "supplierCustomerId",
                    //     "validFrom",
                    //     "orderRhythm"
                    // ]
                    // const result = this.ocJsonSchemaValidatorAjv.validateData("supplierDeliveryTermDay", this.orderdaysModalForm.getRawValue());
                    // if (!this.orderdaysModalForm.get('changed').touched && result.isValid) {
                    //     this.orderdaysModalForm.get('changed').markAsTouched();
                    // } else if (!result.isValid) {
                    //     this.orderdaysModalForm.get('changed').markAsUntouched();
                    // }
                    this.orderdaysModalForm.get('changed').markAsTouched();
                } else {
                    this.orderdaysModalForm.get('changed').markAsUntouched();
                }
            },
            error: (err: IError) => {
                this.utilityHelperService.handleComponentError(err);
            },
        });
        // SUBSCRIBE: dateFromForm
        // BRAUCHT MAN NICHT, HIER VIA onDateChange() gelöst !!!
        // this.orderdaysModalForm.get('dateFromForm').valueChanges.subscribe(event => {
        //     if (this.orderdaysModalForm.get('dateFromForm').get('date').value.singleDate
        //         && this.orderdaysModalForm.get('dateFromForm').get('date').value.singleDate.formatted
        //         && this.orderdaysModalForm.get('dateFromForm').get('date').value.singleDate.formatted.length > 0) {
        //         //
        //         if (this.orderdaysModalForm.get('dateTillForm').get('date').value
        //             && this.orderdaysModalForm.get('dateTillForm').get('date').value.singleDate
        //             && this.orderdaysModalForm.get('dateTillForm').get('date').value.singleDate.jsDate) {
        //             // console.log('---> ' + this.orderdaysModalForm.get('dateFromForm').get('date').value.singleDate.jsDate);
        //             console.log('---> ' + event.date.singleDate.jsDate + ' > ' + this.orderdaysModalForm.get('dateTillForm').get('date').value.singleDate.jsDate);
        //             if (event.date.singleDate.jsDate > this.orderdaysModalForm.get('dateTillForm').get('date').value.singleDate.jsDate) {
        //                 this.orderdaysModalForm.get('dateTillForm').setValue(this.orderdaysModalForm.get('dateFromForm').value)
        //             }
        //         }
        //         // OPTION.disableUntil setzen
        //         (this.orderdaysModalForm.get('dateTillForm').get('options').value as IAngularMyDpOptions).disableUntil = this.coreService.convertToMyDate(event.date.singleDate.jsDate);
        //         this.orderdaysModalForm.get('dateTillForm').get('options').setValue(Object.assign({}, this.orderdaysModalForm.get('dateTillForm').get('options').value));
        //
        //         this.dateFromFormDateValid = true;
        //     } else {
        //         this.dateFromFormDateValid = false;
        //     }
        // })
    }

    initDeliverydaysCustomerModalForm(supplierDeliveryTermDays?: ISupplierDeliveryTermDays) {
        if (supplierDeliveryTermDays !== undefined) {
            this.deliverydaysCustomerModalForm = this.formBuilder.group({
                id: supplierDeliveryTermDays.id,
                dateFromForm: this.formBuilder.group({
                    date: supplierDeliveryTermDays.validFrom
                        ? {
                              isRange: false,
                              dateFormat: 'dd.mm.yyyy',
                              singleDate: { jsDate: new Date(supplierDeliveryTermDays.validFrom) },
                              dateRange: false,
                          }
                        : this.dateModelFrom,
                    options: supplierDeliveryTermDays.validFrom
                        ? {
                              disableSince: this.coreService.convertToMyDate(moment(0).toDate()),
                          }
                        : {
                              disableUntil: this.coreService.convertToMyDate(moment(new Date()).toDate()),
                              disableDateRanges: this.getDisableDateRangesForDaysFrom(this.deliveryFormType),
                          },
                }),
                dateTillForm: this.formBuilder.group({
                    date: [
                        supplierDeliveryTermDays.validTill
                            ? {
                                  isRange: false,
                                  singleDate: { jsDate: new Date(supplierDeliveryTermDays.validTill) },
                              }
                            : this.dateModelTill,
                    ],
                    // VARIANTE A: wenn dateFrom gefüllt ist, muss es nach dateFrom sein
                    // options: supplierDeliveryTermDays.dateFrom ? {
                    //     disableUntil: this.coreService.convertToMyDate(new Date(supplierDeliveryTermDays.dateFrom))
                    // } : {
                    //     disableUntil: this.coreService.convertToMyDate(new Date())
                    // }
                    // VARIANTE B: Änderungen immer max ab heutigem Tag, hier kann es zu einem NgViewAfterInit Error kommen, wenn der ausgewählte Wert im DISABLED-Bereich liegt

                    options: this.getDateTillFormOptions(this.deliveryFormType, supplierDeliveryTermDays),
                }),
                dayforms: this.formBuilder.array([
                    this.formBuilder.group({
                        day: OCDay.MONDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayMon,
                        time: supplierDeliveryTermDays.isWeekdayMon
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeMon)
                            : this.emptyTimeDelivery,
                    }),
                    this.formBuilder.group({
                        day: OCDay.TUESDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayTue,
                        time: supplierDeliveryTermDays.isWeekdayTue
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeTue)
                            : this.emptyTimeDelivery,
                    }),
                    this.formBuilder.group({
                        day: OCDay.WEDNESDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayWed,
                        time: supplierDeliveryTermDays.isWeekdayWed
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeWed)
                            : this.emptyTimeDelivery,
                    }),
                    this.formBuilder.group({
                        day: OCDay.THURSDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayThu,
                        time: supplierDeliveryTermDays.isWeekdayThu
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeThu)
                            : this.emptyTimeDelivery,
                    }),
                    this.formBuilder.group({
                        day: OCDay.FRIDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdayFri,
                        time: supplierDeliveryTermDays.isWeekdayFri
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeFri)
                            : this.emptyTimeDelivery,
                    }),
                    this.formBuilder.group({
                        day: OCDay.SATURDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdaySat,
                        time: supplierDeliveryTermDays.isWeekdaySat
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeSat)
                            : this.emptyTimeDelivery,
                    }),
                    this.formBuilder.group({
                        day: OCDay.SUNDAY,
                        isWeekday: supplierDeliveryTermDays.isWeekdaySun,
                        time: supplierDeliveryTermDays.isWeekdaySun
                            ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermDays.timeSun)
                            : this.emptyTimeDelivery,
                    }),
                ]),
                isLast: this.isLastDeliveryTermDays(this.deliveryFormType, supplierDeliveryTermDays.id),
                changed: false,
            });
        } else {
            this.deliverydaysCustomerModalForm = this.formBuilder.group({
                id: undefined,
                dateFromForm: this.formBuilder.group({
                    date: [this.dateModelFrom],
                    // options: new DatepickerHelper().datePickerOptions
                    options: {
                        dateRange: false,
                        dateFormat: 'dd.mm.yyyy',
                        disableUntil: this.coreService.convertToMyDate(moment(new Date()).toDate()),
                        disableDateRanges: this.getDisableDateRangesForDaysFrom(this.deliveryFormType),
                    },
                }),
                dateTillForm: this.formBuilder.group({
                    date: [this.dateModelTill],
                    // options: new DatepickerHelper().datePickerOptions
                    options: this.getDateTillFormOptions(this.deliveryFormType, {} as ISupplierDeliveryTermDays),
                }),
                dayforms: this.getEmptyWeekFormArray(this.deliveryFormType),
                isLast: true,
                changed: false,
            });
        }
        // INIT
        if (supplierDeliveryTermDays !== undefined && supplierDeliveryTermDays.validFrom) {
            this.dateFromFormDateValid = true;
        } else {
            this.dateFromFormDateValid = false;
        }
        // SUBSCRIBE: deliverydaysCustomerModalForm
        this.deliverydaysCustomerModalForm.valueChanges.pipe(untilDestroyed(this)).subscribe(
            (change) => {
                // !this.deliverydaysCustomerModalForm.get('changed').touched &&
                if (
                    this.dateFromFormDateValid &&
                    this.dayformChoosen(this.deliverydaysCustomerModalForm) &&
                    (!this.deliverydaysCustomerModalForm.get('dateTillForm').get('date').value?.singleDate?.jsDate ||
                        this.deliverydaysCustomerModalForm.get('dateTillForm').get('date').value?.singleDate?.jsDate >
                            this.deliverydaysCustomerModalForm.get('dateFromForm').get('date').value?.singleDate?.jsDate)
                ) {
                    this.deliverydaysCustomerModalForm.get('changed').markAsTouched();
                } else {
                    this.deliverydaysCustomerModalForm.get('changed').markAsUntouched();
                }
            },
            (err: IError) => {
                this.utilityHelperService.handleComponentError(err);
            },
        );
        // SUBSCRIBE: dateFromForm
        // BRAUCHT MAN NICHT, HIER VIA onDateChange() gelöst !!!
        // this.deliverydaysCustomerModalForm.get('dateFromForm').valueChanges.subscribe(event => {
        //     if (this.deliverydaysCustomerModalForm.get('dateFromForm').get('date').value.singleDate
        //         && this.deliverydaysCustomerModalForm.get('dateFromForm').get('date').value.singleDate.formatted
        //         && this.deliverydaysCustomerModalForm.get('dateFromForm').get('date').value.singleDate.formatted.length > 0) {
        //         //
        //         if (this.deliverydaysCustomerModalForm.get('dateTillForm').get('date').value
        //             && this.deliverydaysCustomerModalForm.get('dateTillForm').get('date').value.singleDate
        //             && this.deliverydaysCustomerModalForm.get('dateTillForm').get('date').value.singleDate.jsDate) {
        //             // console.log('---> ' + this.deliverydaysCustomerModalForm.get('dateFromForm').get('date').value.singleDate.jsDate);
        //             console.log('---> ' + event.date.singleDate.jsDate + ' > ' + this.deliverydaysCustomerModalForm.get('dateTillForm').get('date').value.singleDate.jsDate);
        //             if (event.date.singleDate.jsDate > this.deliverydaysCustomerModalForm.get('dateTillForm').get('date').value.singleDate.jsDate) {
        //                 //this.certificationForm.get('dateTillForm').get('options').setValue(Object.assign({}, this.certificationForm.get('dateTillForm').get('options').value));
        //                 this.deliverydaysCustomerModalForm.get('dateTillForm').setValue(this.deliverydaysCustomerModalForm.get('dateFromForm').value)
        //             }
        //         }
        //         // OPTION.disableUntil setzen
        //         (this.deliverydaysCustomerModalForm.get('dateTillForm').get('options').value as IAngularMyDpOptions).disableUntil = this.coreService.convertToMyDate(event.date.singleDate.jsDate);
        //         this.deliverydaysCustomerModalForm.get('dateTillForm').get('options').setValue(Object.assign({}, this.deliverydaysCustomerModalForm.get('dateTillForm').get('options').value));
        //         //
        //         this.dateFromFormDateValid = true;
        //     } else {
        //         this.dateFromFormDateValid = false;
        //     }
        // })
    }

    dayformChoosen(formGroup: UntypedFormGroup): boolean {
        let dayCheckBoxChoosen: boolean = false;
        const mondayGroup = (formGroup.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.MONDAY);
        const tuesdayGroup = (formGroup.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.TUESDAY);
        const wednesdayGroup = (formGroup.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.WEDNESDAY);
        const thursdayGroup = (formGroup.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.THURSDAY);
        const fridayGroup = (formGroup.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.FRIDAY);
        const saturdayGroup = (formGroup.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.SATURDAY);
        const sundayGroup = (formGroup.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.SUNDAY);
        if (
            mondayGroup.get('isWeekday').value ||
            tuesdayGroup.get('isWeekday').value ||
            wednesdayGroup.get('isWeekday').value ||
            thursdayGroup.get('isWeekday').value ||
            fridayGroup.get('isWeekday').value ||
            saturdayGroup.get('isWeekday').value ||
            sundayGroup.get('isWeekday').value
        ) {
            dayCheckBoxChoosen = true;
        }
        return dayCheckBoxChoosen;
    }
    initDeliveryTermHolidaysModalForm(supplierDeliveryTermHoliday?: ISupplierDeliveryTermHolidays) {
        this.deliveryTermHolidaysModalForm = this.formBuilder.group({
            id: supplierDeliveryTermHoliday !== undefined ? supplierDeliveryTermHoliday.id : undefined,
            time:
                supplierDeliveryTermHoliday !== undefined && supplierDeliveryTermHoliday.timeHoliday !== undefined
                    ? this.supplierService.convertStringtimeToNgbdatepickerTime(supplierDeliveryTermHoliday.timeHoliday)
                    : this.emptyTimeDelivery,
            holiday: supplierDeliveryTermHoliday !== undefined ? supplierDeliveryTermHoliday.holiday.id : this.holidayList[0].id,
            changed: false,
        });
        this.deliveryTermHolidaysModalForm.valueChanges.pipe(untilDestroyed(this)).subscribe(
            (change) => {
                if (!this.deliveryTermHolidaysModalForm.get('changed').touched) this.deliveryTermHolidaysModalForm.get('changed').markAsTouched();
            },
            (err: IError) => {
                this.utilityHelperService.handleComponentError(err);
            },
        );
        //
        const options: NgbModalOptions = { centered: false, backdrop: 'static', size: 'lg' };
        this.modalService.openModal(this.deliveryTermHolidaysModal(), options);
    }

    saveOrderday() {
        this.modalService.closeAllModals();
        this.loadingOverlayService.startLoading();

        const dateFromPicker = this.orderdaysModalForm.get('dateFromForm').get('date').value.singleDate
            ? this.orderdaysModalForm.get('dateFromForm').get('date').value.singleDate.jsDate
            : undefined;
        const dateTillPicker = this.orderdaysModalForm.get('dateTillForm').get('date').value?.singleDate
            ? this.orderdaysModalForm.get('dateTillForm').get('date').value.singleDate.jsDate
            : undefined;

        const mondayGroup = (this.orderdaysModalForm.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.MONDAY);
        const tuesdayGroup = (this.orderdaysModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.TUESDAY,
        );
        const wednesdayGroup = (this.orderdaysModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.WEDNESDAY,
        );
        const thursdayGroup = (this.orderdaysModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.THURSDAY,
        );
        const fridayGroup = (this.orderdaysModalForm.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.FRIDAY);
        const saturdayGroup = (this.orderdaysModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.SATURDAY,
        );
        const sundayGroup = (this.orderdaysModalForm.get('dayforms') as UntypedFormArray).controls.find((element) => element.get('day').value === OCDay.SUNDAY);

        // moment(mondayGroup.get('time')).locale(this.environmentService.appSettings.locale).format('L')

        const orderDay: ISupplierDeliveryTermDays = {
            id: this.orderdaysModalForm.get('id').value,
            validFrom: dateFromPicker ? dateFromPicker : undefined,
            validTill: dateTillPicker ? dateTillPicker : undefined,
            isDelivery: false,
            isOrder: true,
            isOrderRhythmMonthly: +this.orderdaysModalForm.get('rhythm').value === 2,
            isOrderRhythmWeekly: +this.orderdaysModalForm.get('rhythm').value === 1,
            orderRhythm: this.orderdaysModalForm.get('orderRhythm').value,
            // supplierContractCostcenterCustomerId: this.supplierContractCostcenterCustomer.id,
            supplierCustomerId: this.supplierContractCostcenterCustomer.supplierCustomer.id,
            isWeekdayMon: mondayGroup.get('isWeekday').value,
            timeMon: mondayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(mondayGroup.get('time').value) : undefined,
            isWeekdayTue: tuesdayGroup.get('isWeekday').value,
            timeTue: tuesdayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(tuesdayGroup.get('time').value) : undefined,
            isWeekdayWed: wednesdayGroup.get('isWeekday').value,
            timeWed: wednesdayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(wednesdayGroup.get('time').value) : undefined,
            isWeekdayThu: thursdayGroup.get('isWeekday').value,
            timeThu: thursdayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(thursdayGroup.get('time').value) : undefined,
            isWeekdayFri: fridayGroup.get('isWeekday').value,
            timeFri: fridayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(fridayGroup.get('time').value) : undefined,
            isWeekdaySat: saturdayGroup.get('isWeekday').value,
            timeSat: saturdayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(saturdayGroup.get('time').value) : undefined,
            isWeekdaySun: sundayGroup.get('isWeekday').value,
            timeSun: sundayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(sundayGroup.get('time').value) : undefined,
            orderLeadTimeDays: this.orderdaysModalForm.get('orderLeadTimeDays').value,
        };

        this.orderdaysTableModel = this.orderdaysTableModel.concat();

        this.supplierService
            .saveSupplierDeliveryOrderday(orderDay)
            .pipe(take(1))
            .subscribe({
                next: (orderdayResponse) => {
                    switch (this.systemMethod) {
                        case SystemMethod.EDIT:
                            this.updateOrderDaysInCollections(orderdayResponse);
                            this.sortOrderDaysCollections();
                            break;
                        case SystemMethod.NEW:
                            this.supplierDeliveryTermOrderdays.push(orderdayResponse);
                            this.addOrderdayMappedToTableModel(orderdayResponse);
                            this.sortOrderDaysCollections();
                            break;
                    }

                    if (!this.checkAllValidTillSet(this.orderFormType)) {
                        this.setValidTillForOtherDays(this.orderFormType);
                    } else {
                        this.sortOrderDaysCollections();
                        this.loadingOverlayService.stopLoading();
                    }
                },
                error: (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            });
    }

    private sortDeliveryDaysCollections() {
        this.supplierDeliveryTermDeliverdays = this.sortDaysByValidFrom(this.supplierDeliveryTermDeliverdays);
        this.deliverdaysTableModel = this.sortDeliveryDaysByDateFrom(this.deliverdaysTableModel);
    }

    private sortOrderDaysCollections() {
        this.supplierDeliveryTermOrderdays = this.sortDaysByValidFrom(this.supplierDeliveryTermOrderdays);
        this.orderdaysTableModel = this.sortOrderDaysByDateFrom(this.orderdaysTableModel);
    }

    private updateDeliveryDaysInCollections(orderDay: ISupplierDeliveryTermDays) {
        let indexElement = this.supplierDeliveryTermDeliverdays.findIndex((od) => od.id === orderDay.id);
        this.supplierDeliveryTermDeliverdays[indexElement] = orderDay;
        indexElement = this.deliverdaysTableModel.findIndex((od) => od.id === orderDay.id);
        this.deliverdaysTableModel[indexElement] = this.supplierService.convertToDeliveryDayTableModel(orderDay);
    }

    private updateOrderDaysInCollections(orderDay: ISupplierDeliveryTermDays) {
        let indexElement = this.supplierDeliveryTermOrderdays.findIndex((od) => od.id === orderDay.id);
        this.supplierDeliveryTermOrderdays[indexElement] = orderDay;
        indexElement = this.orderdaysTableModel.findIndex((od) => od.id === orderDay.id);
        this.orderdaysTableModel[indexElement] = this.supplierService.convertToOrderdayTableModel(orderDay);
    }

    private setValidTillForOtherDays(formType: string) {
        let days: ISupplierDeliveryTermDays[] = [];
        if (formType === this.orderFormType) {
            days = this.supplierDeliveryTermOrderdays;
        } else if (formType === this.deliveryFormType) {
            days = this.supplierDeliveryTermDeliverdays;
        }

        const daysSorted: ISupplierDeliveryTermDays[] = this.sortDaysByValidFrom(days, 'desc');

        let from: string;
        const touchedDaysIndex: number[] = [];
        const daysSortedWithValidTillSet = daysSorted.map((day, index, arr) => {
            // if first day, skip, it must not have validTill
            if (index === 0 || !!day.validTill) {
                from = day.validFrom;

                return day;
            }
            day.validTill = moment(new Date(from)).subtract(1, 'days').toISOString();
            from = day.validFrom;
            touchedDaysIndex.push(index);

            return day;
        });

        let observableBatch = [];
        if (formType === this.orderFormType) {
            observableBatch = touchedDaysIndex.map((index) =>
                this.supplierService.saveSupplierDeliveryOrderday(daysSortedWithValidTillSet[index]).pipe(take(1)),
            );
        } else if (formType === this.deliveryFormType) {
            observableBatch = touchedDaysIndex.map((index) => this.supplierService.saveSupplierDeliveryday(daysSortedWithValidTillSet[index]).pipe(take(1)));
        }

        forkJoin(observableBatch)
            .pipe(take(1))
            .subscribe(
                (results: ISupplierDeliveryTermDays[]) => {
                    if (formType === this.orderFormType) {
                        results.forEach((resultDays) => {
                            this.updateOrderDaysInCollections(resultDays);
                        });
                        this.sortOrderDaysCollections();
                    } else if (formType === this.deliveryFormType) {
                        results.forEach((resultDays) => {
                            this.updateDeliveryDaysInCollections(resultDays);
                        });
                        this.sortDeliveryDaysCollections();
                    }
                    //
                    this.loadingOverlayService.stopLoading();
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    saveDeliverydays() {
        this.modalService.closeAllModals();
        this.setValidTillHintModalVersion = '';
        this.loadingOverlayService.startLoading();

        const dateFromPicker = this.deliverydaysCustomerModalForm.get('dateFromForm').get('date').value.singleDate
            ? this.deliverydaysCustomerModalForm.get('dateFromForm').get('date').value.singleDate.jsDate
            : undefined;
        const dateTillPicker = this.deliverydaysCustomerModalForm.get('dateTillForm').get('date').value?.singleDate
            ? this.deliverydaysCustomerModalForm.get('dateTillForm').get('date').value.singleDate.jsDate
            : undefined;

        const mondayGroup = (this.deliverydaysCustomerModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.MONDAY,
        );
        const tuesdayGroup = (this.deliverydaysCustomerModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.TUESDAY,
        );
        const wednesdayGroup = (this.deliverydaysCustomerModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.WEDNESDAY,
        );
        const thursdayGroup = (this.deliverydaysCustomerModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.THURSDAY,
        );
        const fridayGroup = (this.deliverydaysCustomerModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.FRIDAY,
        );
        const saturdayGroup = (this.deliverydaysCustomerModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.SATURDAY,
        );
        const sundayGroup = (this.deliverydaysCustomerModalForm.get('dayforms') as UntypedFormArray).controls.find(
            (element) => element.get('day').value === OCDay.SUNDAY,
        );

        const tempSupplierDeliveryTermDay: ISupplierDeliveryTermDays = {
            id: this.deliverydaysCustomerModalForm.get('id').value,
            validFrom: dateFromPicker ? dateFromPicker : undefined,
            validTill: dateTillPicker ? dateTillPicker : undefined,
            isDelivery: true,
            isOrder: false,
            // supplierContractCostcenterCustomerId: this.supplierContractCostcenterCustomer.id,
            supplierCustomerId: this.supplierContractCostcenterCustomer.supplierCustomer.id,
            isWeekdayMon: mondayGroup.get('isWeekday').value,
            timeMon: mondayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(mondayGroup.get('time').value) : undefined,
            isWeekdayTue: tuesdayGroup.get('isWeekday').value,
            timeTue: tuesdayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(tuesdayGroup.get('time').value) : undefined,
            isWeekdayWed: wednesdayGroup.get('isWeekday').value,
            timeWed: wednesdayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(wednesdayGroup.get('time').value) : undefined,
            isWeekdayThu: thursdayGroup.get('isWeekday').value,
            timeThu: thursdayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(thursdayGroup.get('time').value) : undefined,
            isWeekdayFri: fridayGroup.get('isWeekday').value,
            timeFri: fridayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(fridayGroup.get('time').value) : undefined,
            isWeekdaySat: saturdayGroup.get('isWeekday').value,
            timeSat: saturdayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(saturdayGroup.get('time').value) : undefined,
            isWeekdaySun: sundayGroup.get('isWeekday').value,
            timeSun: sundayGroup.get('isWeekday').value ? this.getTimepickervalueAsTime(sundayGroup.get('time').value) : undefined,
            orderLeadTimeDays: undefined,
        };

        this.supplierService
            .saveSupplierDeliveryday(tempSupplierDeliveryTermDay)
            .pipe(take(1))
            .subscribe(
                (supplierDeliveryday) => {
                    switch (this.systemMethod) {
                        case SystemMethod.EDIT:
                            this.updateDeliveryDaysInCollections(supplierDeliveryday);
                            this.sortDeliveryDaysCollections();
                            break;
                        case SystemMethod.NEW:
                            this.supplierDeliveryTermDeliverdays.push(supplierDeliveryday);
                            this.addDeliverydayMappedToTableModel(supplierDeliveryday);
                            this.sortDeliveryDaysCollections();
                            break;
                    }
                    if (!this.checkAllValidTillSet(this.deliveryFormType)) {
                        this.setValidTillForOtherDays(this.deliveryFormType);
                    } else {
                        this.sortDeliveryDaysCollections();
                        this.loadingOverlayService.stopLoading();
                    }
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    saveDeliveryTermHoliday() {
        const supplierDeliveryTermHoliday: ISupplierDeliveryTermHolidays = {
            id: this.deliveryTermHolidaysModalForm.get('id').value,
            holiday: this.environmentService.holidayHash.get(this.deliveryTermHolidaysModalForm.get('holiday').value),
            supplierCustomerId: this.supplierContractCostcenterCustomer.supplierCustomer.id,
            timeHoliday: this.getTimepickervalueAsTime(this.deliveryTermHolidaysModalForm.get('time').value),
            _holidayDateDSP: moment(new Date(this.environmentService.holidayHash.get(this.deliveryTermHolidaysModalForm.get('holiday').value).holidayDate))
                .locale(this.environmentService.appSettings.locale)
                .format('L'),
        };

        this.loadingOverlayService.startLoading();
        this.supplierService
            .saveSupplierHoliday(supplierDeliveryTermHoliday)
            .pipe(take(1))
            .subscribe(
                (holidayResponse) => {
                    switch (this.systemMethod) {
                        case SystemMethod.EDIT:
                            holidayResponse._holidayDateDSP = moment(new Date(holidayResponse.holiday.holidayDate))
                                .locale(this.environmentService.appSettings.locale)
                                .format('L');
                            const indexElement = this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays.findIndex(
                                (holiday) => holiday.id === supplierDeliveryTermHoliday.id,
                            );
                            this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays[indexElement] = holidayResponse;
                            break;
                        case SystemMethod.NEW:
                            holidayResponse._holidayDateDSP = moment(new Date(holidayResponse.holiday.holidayDate))
                                .locale(this.environmentService.appSettings.locale)
                                .format('L');
                            this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays.push(holidayResponse);
                            break;
                    }
                    this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays =
                        this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays.concat();
                    this.loadingOverlayService.stopLoading();
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    getTimepickervalueAsTime(timepicker: ITimepickerModel): string {
        // console.log(moment(7200000).locale(this.environmentService.appSettings.locale).utcOffset());
        return (timepicker.hour >= 10 ? '' : '0') + timepicker.hour + ':' + (timepicker.minute >= 10 ? '' : '0') + timepicker.minute;
    }

    // NOTE: Strukturumstellung supplierDeliveryTerm ist weggefallen
    // openDeliveryConditionModal(supplierDeliveryTerm?: ISupplierDeliveryTerm) {
    //     this.systemMethod = supplierDeliveryTerm !== undefined ? SystemMethod.EDIT : SystemMethod.NEW;
    //     this.initDeliveryConditionModalForm(supplierDeliveryTerm);
    //     const options: NgbModalOptions = {centered: false, backdrop: 'static', size: 'lg'};
    //     this.modalService.openModal(this.deliveryTermsModal, options);
    // }

    openOrderdaysModal(orderFrequency?: IOrderFrequency) {
        let supplierDeliveryTermDays: ISupplierDeliveryTermDays;
        if (orderFrequency !== undefined) {
            this.systemMethod = SystemMethod.EDIT;
            // supplierDeliveryTermDays =  this.supplierService.convertToOrderday(orderFrequency, this.supplierContractCostcenterCustomer.id);
            supplierDeliveryTermDays = this.supplierService.convertToOrderday(orderFrequency, this.supplierContractCostcenterCustomer.supplierCustomer.id);
        } else this.systemMethod = SystemMethod.NEW;
        this.initOrderdaysModalForm(supplierDeliveryTermDays);
        const options: NgbModalOptions = { centered: false, backdrop: 'static', size: 'lg' };
        this.modalService.openModal(this.orderdaysModal(), options);
    }

    openDeliverydaysCustomerModal(week?: IWeek) {
        let supplierDeliveryTermDays: ISupplierDeliveryTermDays;
        if (week !== undefined) {
            this.systemMethod = SystemMethod.EDIT;
            // supplierDeliveryTermDays =  this.supplierService.convertToDeliveryday(week, this.supplierContractCostcenterCustomer.id);
            supplierDeliveryTermDays = this.supplierService.convertToDeliveryday(week, this.supplierContractCostcenterCustomer.supplierCustomer.id);
        } else this.systemMethod = SystemMethod.NEW;
        this.initDeliverydaysCustomerModalForm(supplierDeliveryTermDays);
        const options: NgbModalOptions = { centered: false, backdrop: 'static', size: 'lg' };
        this.modalService.openModal(this.deliverydaysCustomerModal(), options);
    }

    openDeliveryTermHolidaysModal(supplierDeliveryTermHolidays?: ISupplierDeliveryTermHolidays) {
        this.systemMethod = supplierDeliveryTermHolidays !== undefined ? SystemMethod.EDIT : SystemMethod.NEW;
        if (this.systemMethod === SystemMethod.EDIT) {
            this.holidayList = [];
            // SystemMethod.EDIT
            this.holidayList.push(supplierDeliveryTermHolidays.holiday);
            //
            this.checkHolidayListAndOpenModal(supplierDeliveryTermHolidays);
        } else {
            // SystemMethod.NEW
            if (
                this.supplierService.supplierBasedata.mainAddress &&
                this.supplierService.supplierBasedata.mainAddress.address &&
                this.supplierService.supplierBasedata.mainAddress.address.stateId
            ) {
                // Supplier.mainAddress ist bereits gefüllt, nur relevante Feiertage anzeigen
                this.holidayList = this.environmentService.holidayList.filter(
                    (h) => !this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays.find((sdth) => sdth.holiday.id === h.id),
                );
                if (this.holidayList && this.holidayList.length > 0) {
                    // Filter actual and future holidays
                    this.filterHolidayListForEdit(supplierDeliveryTermHolidays);
                    //
                    this.checkHolidayListAndOpenModal(supplierDeliveryTermHolidays);
                } else {
                    // TODO: ggf. Feiertagsliste holen über Service.
                    this.coreService
                        .getHolidays(LockedType.NOTLOCKED)
                        .pipe(take(1))
                        .subscribe({
                            next: (data: any) => {
                                // Supplier.mainAddress ist bereits gefüllt, nur relevante Feiertage anzeigen
                                this.holidayList = this.environmentService.holidayList.filter(
                                    (h) => !this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays.find((sdth) => sdth.holiday.id === h.id),
                                );
                                // Filter actual and future holidays
                                this.filterHolidayListForEdit(supplierDeliveryTermHolidays);
                                //
                                this.checkHolidayListAndOpenModal(supplierDeliveryTermHolidays);
                            },
                            error: (err: IError) => {
                                this.utilityHelperService.handleComponentError(err);
                            },
                        });
                }
            } else {
                // Feiertage können nicht angezeigt werden, weil noch kein State und Country zugeordnet ist !!!
                console.error('Feiertage können nicht angezeigt werden, weil noch kein State und Country zugeordnet ist !!!');
            }
        }
    }
    private filterHolidayListForEdit(supplierDeliveryTermHolidays: ISupplierDeliveryTermHolidays) {
        if (this.environmentService.countryList && this.environmentService.countryList.length > 0) {
            const country = this.environmentService.countryList.find((c) =>
                c.states.find((s) => s && s.id === this.supplierService.supplierBasedata.mainAddress.address.stateId),
            );
            this.holidayList = this.holidayList.filter(
                (h) => (!h.stateId && h.countryId === country.id) || h.stateId === this.supplierService.supplierBasedata.mainAddress.address.stateId,
            );
        }

        const now = new Date();
        this.holidayList = this.holidayList.filter((h) => new Date(h.holidayDate) > now);
    }
    private checkHolidayListAndOpenModal(supplierDeliveryTermHolidays: ISupplierDeliveryTermHolidays) {
        if (this.holidayList && this.holidayList.length > 0) {
            this.initDeliveryTermHolidaysModalForm(supplierDeliveryTermHolidays);
        } else {
            this.appService.showToast(
                'error',
                this.coreService.getMsgkey('mws.error.configuration.noholidays.text', undefined),
                this.coreService.getMsgkey('mws.error.configuration.noholidays.headline', undefined),
            );
        }
    }
    // NOTE: Strukturumstellung supplierDeliveryTerm ist weggefallen
    // archiveConditionsOpenModal(elementId: number) {
    //     this.tempElementId = elementId;
    //     this.archiveElementHeader = 'mws.archiveDeliveryConditionsHeadline';
    //     this.archiveElementText = 'mws.archiveDeliveryConditionsText';
    //     this.archiveElementType = ArchiveType.DELIVERYTERMSCONDITION;
    //     const options: NgbModalOptions = {centered: false, backdrop: 'static', size: 'lg'};
    //     this.modalService.openModal(this.archiveElementModal, options);
    // }

    // archiveOrderdaysOpenModal(elementId: number) {
    //     this.tempElementId = elementId;
    //     this.archiveElementHeader = 'mws.archiveDeliveryOrderdaysHeadline';
    //     this.archiveElementText = 'mws.archiveDeliveryOrderdaysText';
    //     this.archiveElementType = ArchiveType.DELIVERYTERMSORDERDAY;
    //     const options: NgbModalOptions = {centered: false, backdrop: 'static', size: 'lg'};
    //     this.modalService.openModal(this.archiveElementModal, options);
    // }
    //
    // archiveDeliverydaysOpenModal(elementId: number) {
    //     this.tempElementId = elementId;
    //     this.archiveElementHeader = 'mws.archiveDeliverydaysHeadline';
    //     this.archiveElementText = 'mws.archiveDeliverydaysText';
    //     this.archiveElementType = ArchiveType.DELIVERYTERMSDELIVERYDAYS;
    //     const options: NgbModalOptions = {centered: false, backdrop: 'static', size: 'lg'};
    //     this.modalService.openModal(this.archiveElementModal, options);
    // }

    archiveHolidaysOpenModal(elementId: number) {
        this.tempElementId = elementId;
        this.archiveElementHeader = 'mws.archivesupplierholidaydeliveryheadline';
        this.archiveElementText = 'mws.archivesupplierholidaydeliverytext';
        this.archiveElementType = ArchiveType.DELIVERYTERMSHOLIDAYS;
        const options: NgbModalOptions = { centered: false, backdrop: 'static', size: 'lg' };
        this.modalService.openModal(this.archiveElementModal(), options);
    }

    // NOTE: Strukturumstellung supplierDeliveryTerm ist weggefallen
    // archiveConditions() {
    //     const indexElement = this.supplierService.supplierContractCostcenterCustomerDetails.supplierDeliveryTerms.findIndex(condition => condition.id === this.tempElementId);
    //     this.supplierService.supplierContractCostcenterCustomerDetails.supplierDeliveryTerms.splice(indexElement, 1);
    //     this.supplierService.supplierContractCostcenterCustomerDetails.supplierDeliveryTerms = this.supplierService.supplierContractCostcenterCustomerDetails.supplierDeliveryTerms.concat();
    // }

    archiveOrderdays() {
        let indexElement = this.supplierDeliveryTermOrderdays.findIndex((orderday) => orderday.id === this.tempElementId);
        this.supplierDeliveryTermOrderdays.splice(indexElement, 1);
        indexElement = this.orderdaysTableModel.findIndex((orderday) => orderday.id === this.tempElementId);
        this.orderdaysTableModel.splice(indexElement, 1);
        this.orderdaysTableModel = this.orderdaysTableModel.concat();
        this.supplierDeliveryTermOrderdays = this.supplierDeliveryTermOrderdays.concat();

        this.resetArchiveModal();
    }

    archiveDeliverydays() {
        let indexElement = this.supplierDeliveryTermDeliverdays.findIndex((deliveryday) => deliveryday.id === this.tempElementId);
        this.supplierDeliveryTermDeliverdays.splice(indexElement, 1);
        indexElement = this.deliverdaysTableModel.findIndex((deliveryday) => deliveryday.id === this.tempElementId);
        this.deliverdaysTableModel.splice(indexElement, 1);
        this.deliverdaysTableModel = this.deliverdaysTableModel.concat();
        this.supplierDeliveryTermDeliverdays = this.supplierDeliveryTermDeliverdays.concat();

        this.resetArchiveModal();
    }

    archiveHolidays() {
        const indexElement = this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays.findIndex(
            (holiday) => holiday.id === this.tempElementId,
        );
        this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays.splice(indexElement, 1);
        this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays =
            this.supplierService.supplierCustomerDetails.supplierDeliveryTermHolidays.concat();
        this.resetArchiveModal();
    }

    archiveElement() {
        this.loadingOverlayService.startLoading();
        switch (this.archiveElementType) {
            // NOTE: Strukturumstellung supplierDeliveryTerm ist weggefallen
            // case ArchiveType.DELIVERYTERMSCONDITION:
            //     this.supplierService.deleteSupplierDeliveryterm(this.tempElementId).subscribe(response => {
            //         // NOTE: Strukturumstellung supplierDeliveryTerm ist weggefallen
            //         // this.archiveConditions();
            //         this.loadingOverlayService.stopLoading();
            //         this.resetArchiveModal();
            //     }, (err: IError) => {
            //         this.utilityHelperService.handleComponentError(err);
            //     });
            //     break;
            case ArchiveType.DELIVERYTERMSDELIVERYDAYS:
                this.supplierService
                    .deleteSupplierDeliveryday(this.tempElementId)
                    .pipe(take(1))
                    .subscribe(
                        (response) => {
                            this.archiveDeliverydays();
                            this.loadingOverlayService.stopLoading();
                            this.resetArchiveModal();
                        },
                        (err: IError) => {
                            this.utilityHelperService.handleComponentError(err);
                        },
                    );
                break;
            case ArchiveType.DELIVERYTERMSHOLIDAYS:
                this.supplierService
                    .deleteSupplierHoliday(this.tempElementId)
                    .pipe(take(1))
                    .subscribe(
                        (response) => {
                            this.archiveHolidays();
                            this.loadingOverlayService.stopLoading();
                            this.resetArchiveModal();
                        },
                        (err: IError) => {
                            this.utilityHelperService.handleComponentError(err);
                        },
                    );
                break;
            case ArchiveType.DELIVERYTERMSORDERDAY:
                this.supplierService
                    .deleteSupplierDeliveryOrderday(this.tempElementId)
                    .pipe(take(1))
                    .subscribe(
                        (response) => {
                            this.archiveOrderdays();
                            this.loadingOverlayService.stopLoading();
                            this.resetArchiveModal();
                        },
                        (err: IError) => {
                            this.utilityHelperService.handleComponentError(err);
                        },
                    );
                break;
            case ArchiveType.SUPPLIERCUSTOMER:
                this.supplierService
                    .deleteSupplierCostcenterCustomer(this.tempElementId)
                    .pipe(take(1))
                    .subscribe(
                        (response) => {
                            // HINWEIS: tempElementId === supplierContractCostcenterCustomerId
                            const iScc = this.supplierService.supplierContractDetail.supplierContractCostcenters[
                                this.indexSupplierContractCostcenters()
                            ].supplierContractCostcenterCustomers.findIndex((sccc) => sccc.id === this.tempElementId);
                            this.supplierService.supplierContractDetail.supplierContractCostcenters[
                                this.indexSupplierContractCostcenters()
                            ].supplierContractCostcenterCustomers.splice(iScc, 1);

                            const iSccc = this.supplierService.supplierContractDetail.supplierContractCostcenterCustomers.findIndex(
                                (sccc) => sccc.id === this.tempElementId,
                            );
                            this.supplierService.supplierContractDetail.supplierContractCostcenterCustomers.splice(iSccc, 1);

                            if (this.hasFavoriteSupplierContractCostcenterCustomer()) {
                                this.loadingOverlayService.stopLoading();

                                return;
                            }

                            this.ensureAtLeastOneFavoriteSupplierCustomer();
                        },
                        (err: IError) => {
                            this.utilityHelperService.handleComponentError(err);
                        },
                    );
                break;
            default:
                this.loadingOverlayService.stopLoading();
                break;
        }
    }

    resetArchiveModal() {
        this.archiveElementHeader = '';
        this.archiveElementText = '';
        this.archiveElementType = null;
        this.tempElementId = null;
    }

    openModal(modal: TemplateRef<any>) {
        this.modalService.openModal(modal);
    }

    getEmptyWeekFormArray(formType: string = ''): UntypedFormArray {
        let emptyTime;
        if (formType === this.orderFormType) {
            emptyTime = this.emptyTimeOrder;
        } else if (formType === this.deliveryFormType) {
            emptyTime = this.emptyTimeDelivery;
        } else {
            emptyTime = this.emptyTime;
        }

        return this.formBuilder.array([
            this.formBuilder.group({
                day: OCDay.MONDAY,
                isWeekday: false,
                time: emptyTime,
            }),
            this.formBuilder.group({
                day: OCDay.TUESDAY,
                isWeekday: false,
                time: emptyTime,
            }),
            this.formBuilder.group({
                day: OCDay.WEDNESDAY,
                isWeekday: false,
                time: emptyTime,
            }),
            this.formBuilder.group({
                day: OCDay.THURSDAY,
                isWeekday: false,
                time: emptyTime,
            }),
            this.formBuilder.group({
                day: OCDay.FRIDAY,
                isWeekday: false,
                time: emptyTime,
            }),
            this.formBuilder.group({
                day: OCDay.SATURDAY,
                isWeekday: false,
                time: emptyTime,
            }),
            this.formBuilder.group({
                day: OCDay.SUNDAY,
                isWeekday: false,
                time: emptyTime,
            }),
        ]);
    }

    /**
     *
     */
    onDateFromChanged(event, formGroup: UntypedFormGroup, formType: string) {
        if (event.singleDate.jsDate) {
            if (
                formGroup.get('dateTillForm').get('date').value?.singleDate?.jsDate &&
                !(formGroup.get('dateTillForm').get('date').value.singleDate.jsDate > event.singleDate.jsDate)
            ) {
                // formGroup.get('dateTillForm').get('date').setValue({
                //         isRange: false,
                //         singleDate: {
                //                 jsDate: moment(event.singleDate.jsDate).add(1, 'days').toDate()
                //         },
                // });
                // formGroup.get('dateTillForm').get('date').setValue(undefined);
                this.appService.showToast('warning', '', this.coreService.getMsgkey('warning.supplier.contract.validtill.invalid', undefined));
            }

            const newValidTillOptions = this.getDateTillFormOptions(formType, { validFrom: event.singleDate.jsDate } as ISupplierDeliveryTermDays);
            formGroup.get('dateTillForm').get('options').setValue(Object.assign({}, newValidTillOptions));

            this.dateFromFormDateValid = true;
        } else {
            this.dateFromFormDateValid = false;
        }

        this.cdr.detectChanges();
    }

    isFavorite() {
        if (this.coreService.checkAbility('update', 'suppliercustomer.favorite')) {
            this.setFavoriteSupplierCustomer();
            // this.deliverytermsForm.get('changed').markAsTouched();
        }
    }

    private getFavoriteSupplierContractCostcenterCustomers() {
        return this.supplierService.supplierContractDetail.supplierContractCostcenters[
            this.indexSupplierContractCostcenters()
        ].supplierContractCostcenterCustomers.filter((sccc) => sccc.isFavorite);
    }

    private hasFavoriteSupplierContractCostcenterCustomer(): boolean {
        return !!this.getFavoriteSupplierContractCostcenterCustomers().length;
    }

    private setFavoriteSupplierCustomer() {
        this.loadingOverlayService.startLoading();
        const tempSupplierCCCustomer = cloneDeep(this.supplierContractCostcenterCustomer);

        // first, unset current favorite
        this.getFavoriteSupplierContractCostcenterCustomers().forEach((sccc) => {
            if (sccc.id !== tempSupplierCCCustomer.id) {
                sccc.isFavorite = false;
                // not neccessary to SAVE, because this makes the BackEnd, folks.
                // this.saveCustomer(sccc, false);
            }
        });

        // then, set the new favorite
        tempSupplierCCCustomer.isFavorite = true;
        this.saveCustomer(tempSupplierCCCustomer, false);
    }

    private ensureAtLeastOneFavoriteSupplierCustomer() {
        if (
            !!this.supplierService.supplierContractDetail.supplierContractCostcenters[this.indexSupplierContractCostcenters()]
                .supplierContractCostcenterCustomers.length
        ) {
            const tempSupplierCCCustomer = cloneDeep(
                this.supplierService.supplierContractDetail.supplierContractCostcenters[this.indexSupplierContractCostcenters()]
                    .supplierContractCostcenterCustomers[0],
            );
            tempSupplierCCCustomer.isFavorite = true;
            this.saveCustomer(tempSupplierCCCustomer, false);
        }
    }

    /*
    ACHTUNG: Soll lt. RA 2020-06-17 momentan nicht angezeigt werden !!!
    Berechnung des nächstmöglichen Bestelltages lt. RA anhand der ersten Bestellung.
     */
    setNextOrderday() {
        // TODO: Berechne nächst möglichen Bestelltag
        this.nextOrderday = moment(new Date()).locale(this.environmentService.appSettings.locale).format('LT');
        // 1. Finde aktuellen Bestellzeitraum (gültigVon - gültigBis) aus Liste
        // 2. erste Bestellung ermitteln ODER letzte Bestellung ---> KLÄREN
        // 3.
    }

    mapWeekdaysLocalized() {
        if (this.supplierService.firstDayOfWeek === 0) {
            // erster Wochentag Sonntag = 0
            this.supplierService.day_0_title = moment().day(0).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_1_title = moment().day(1).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_2_title = moment().day(2).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_3_title = moment().day(3).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_4_title = moment().day(4).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_5_title = moment().day(5).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_6_title = moment().day(6).locale(this.environmentService.appSettings.locale).format('ddd');
        } else {
            // erster Wochentag Montag = 1
            this.supplierService.day_0_title = moment().day(1).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_1_title = moment().day(2).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_2_title = moment().day(3).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_3_title = moment().day(4).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_4_title = moment().day(5).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_5_title = moment().day(6).locale(this.environmentService.appSettings.locale).format('ddd');
            this.supplierService.day_6_title = moment().day(0).locale(this.environmentService.appSettings.locale).format('ddd');
        }
    }

    mapDeliverydayTableModel() {
        // console.log( '-------> DE: ' + moment().locale(this.environmentService.appSettings.locale).startOf('week').get('day').toString() );
        // console.log( '-------> DE: ' + moment().locale(this.environmentService.appSettings.locale).startOf('week').format('dd').toString() );
        // console.log( '-------> US: ' + moment().locale('US').startOf('week').get('day').toString() );
        // console.log( '-------> US: ' + moment().locale('US').startOf('week').format('dd').toString() );
        this.deliverdaysTableModel = [];
        if (this.supplierDeliveryTermDeliverdays && this.supplierDeliveryTermDeliverdays.length > 0) {
            this.supplierDeliveryTermDeliverdays.forEach((sdtd) => {
                this.addDeliverydayMappedToTableModel(sdtd);
            });
            // } else {
            //     console.log('deliveryterms.component - DELIVERYDAYS DATA NOT FOUND');
        }
    }

    mapOrderdayTableModel() {
        this.orderdaysTableModel = [];

        if (this.supplierDeliveryTermOrderdays && this.supplierDeliveryTermOrderdays.length > 0) {
            this.supplierDeliveryTermOrderdays.forEach((sdto) => {
                this.addOrderdayMappedToTableModel(sdto);
            });
            // } else {
            //     console.log('deliveryterms.component - ORDERDAYS DATA NOT FOUND');
        }
    }

    private addOrderdayMappedToTableModel(orderday: ISupplierDeliveryTermDays) {
        this.orderdaysTableModel.push(this.supplierService.convertToOrderdayTableModel(orderday));
    }

    private addDeliverydayMappedToTableModel(supplierDeliveryTermdays: ISupplierDeliveryTermDays) {
        this.deliverdaysTableModel.push(this.supplierService.convertToDeliveryDayTableModel(supplierDeliveryTermdays));
    }

    onSubmitAddress(address: IAddressDisplay) {
        this.loadingOverlayService.startLoading();
        address.addressTypeId = this.environmentService.addressTypeList.find((at) => at.isShipping).id;
        let supplierCustomerAddress: ICustomerAddress = this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.find(
            (sca) => sca.address.id === address.id,
        );
        if (!supplierCustomerAddress) {
            supplierCustomerAddress = {} as ICustomerAddress;
            supplierCustomerAddress.id = undefined;
            supplierCustomerAddress.supplierCustomerId = this.supplierContractCostcenterCustomer.supplierCustomer.id;
        }

        // wg. Neuanlage ggf. mit FALSE vorbelegen !
        supplierCustomerAddress.isFavorite = false;
        if (address._isFavorite) {
            supplierCustomerAddress.isFavorite = address._isFavorite;
        }
        // erste Adresse wird automatisch favorit
        if (
            (!supplierCustomerAddress.id && this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.length === 0) ||
            (supplierCustomerAddress.id && this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.length === 1)
        ) {
            supplierCustomerAddress.isFavorite = true;
        }

        supplierCustomerAddress.address = address;

        const observableBatch = [];
        observableBatch.push(this.getSaveSupplierCustomerAddressRequest(supplierCustomerAddress));

        if (supplierCustomerAddress.isFavorite) {
            this.getSupplierCustomerFavoriteAddresses(supplierCustomerAddress.id).forEach((sCFA) => {
                sCFA.isFavorite = false;
                observableBatch.push(this.getSaveSupplierCustomerAddressRequest(sCFA));
            });
        }

        forkJoin(observableBatch)
            .pipe(take(1))
            .subscribe(
                (results) => {
                    this.supplierService.supplierCustomerDetails.supplierCustomerAddresses =
                        this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.concat();
                    this.fillAddresses();

                    this.modalService.closeAllModals();
                    this.loadingOverlayService.stopLoading();
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    private getSupplierCustomerFavoriteAddresses(excludeAddressId?: number) {
        const supplierCustomerFavoriteAdresses = this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.filter((sCA) => sCA.isFavorite);

        if (!excludeAddressId) {
            return supplierCustomerFavoriteAdresses;
        }

        return supplierCustomerFavoriteAdresses.filter((sCA) => sCA.id !== excludeAddressId);
    }

    private getSaveSupplierCustomerAddressRequest(supplierCustomerAddress: ICustomerAddress) {
        return this.supplierService.saveSupplierCustomerAddresses(supplierCustomerAddress).pipe(
            tap((supplCustAddress: ICustomerAddress) => {
                // TODO: RELOAD supplierCustomerAddresses from database !!!
                const index = this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.findIndex((sca) => sca.id === supplierCustomerAddress.id);
                if (index === -1) {
                    this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.push(supplCustAddress);
                } else {
                    this.supplierService.supplierCustomerDetails.supplierCustomerAddresses[index] = supplCustAddress;
                }
            }),
        );
    }

    public onDeleteAddress(address: IAddressDisplay) {
        if (this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.length === 1) {
            this.deleteAddress(address);
        }

        const favoriteSCA = this.getFavoriteSupplierCustomerAddress();
        const mustSetFavorite = !favoriteSCA || favoriteSCA.address.id === address.id;

        if (this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.length === 2) {
            this.deleteAddress(address, mustSetFavorite);
        }

        if (this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.length > 2) {
            if (mustSetFavorite) {
                this.showSelectNewFavoriteAddressHintModal();
            } else {
                this.deleteAddress(address);
            }
        }
    }

    private deleteAddress(address: IAddressDisplay, mustSetFavorite: boolean = false) {
        this.loadingOverlayService.startLoading();
        this.supplierService
            .deleteSupplierCustomerAddress(address.id)
            .pipe(take(1))
            .subscribe(
                (success) => {
                    // TODO: RELOAD supplierCustomerAddresses from database !!!
                    const scaIndex = this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.findIndex((sca) => sca.address.id === address.id);
                    this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.splice(scaIndex, 1);

                    if (mustSetFavorite && !!this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.length) {
                        this.ensureFavoriteSupplCustAddressSet();
                    } else {
                        this.supplierService.supplierCustomerDetails.supplierCustomerAddresses =
                            this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.concat();
                        this.fillAddresses();

                        this.modalService.closeAllModals();
                        this.loadingOverlayService.stopLoading();
                    }
                },
                (err: IError) => {
                    this.utilityHelperService.handleComponentError(err);
                },
            );
    }

    private getDisableUntilDateForDaysTill(supplierDeliveryTermDays: ISupplierDeliveryTermDays) {
        let highestDisableUntil = new Date();
        // subtract one day to allow ending the delivery terms today, in case validFrom is not in future
        highestDisableUntil.setDate(highestDisableUntil.getDate() - 1);

        if (supplierDeliveryTermDays && supplierDeliveryTermDays.validFrom && new Date(supplierDeliveryTermDays.validFrom) > highestDisableUntil) {
            highestDisableUntil = new Date(supplierDeliveryTermDays.validFrom);
        }

        return this.coreService.convertToMyDate(moment(highestDisableUntil).toDate());
    }

    private getDisableSinceDateForDaysTill(supplierDeliveryTermDays: ISupplierDeliveryTermDays, formType: string) {
        if (supplierDeliveryTermDays && (!isNil(supplierDeliveryTermDays.id) || !!supplierDeliveryTermDays.validFrom)) {
            const nextDeliveryTermDays: ISupplierDeliveryTermDays = this.getNextDeliveryTermDays(supplierDeliveryTermDays, formType);
            if (!isNil(nextDeliveryTermDays)) {
                return this.coreService.convertToMyDate(moment(nextDeliveryTermDays.validFrom).toDate());
            }
        }

        return { year: 0, month: 0, day: 0 };
    }

    private getNextDeliveryTermDays(supplierDeliveryTermDays: ISupplierDeliveryTermDays, formType: string) {
        let nextDeliveryTermDays: ISupplierDeliveryTermDays;
        let days: ISupplierDeliveryTermDays[] = [];
        if (formType === this.orderFormType) {
            days = this.sortDaysByValidFrom(this.supplierDeliveryTermOrderdays);
        } else if (formType === this.deliveryFormType) {
            days = this.sortDaysByValidFrom(this.supplierDeliveryTermDeliverdays);
        }

        if (!isNil(supplierDeliveryTermDays.id) && days.some((d) => d.id === supplierDeliveryTermDays.id)) {
            // METHOD EDIT
            // METHOD EDIT
            // METHOD EDIT
            const elementIndex = days.findIndex((d) => d.id === supplierDeliveryTermDays.id);
            nextDeliveryTermDays = days[elementIndex + 1];
        } else if (!!supplierDeliveryTermDays.validFrom) {
            // METHOD NEW
            // METHOD NEW
            // METHOD NEW
            nextDeliveryTermDays = days.find((d) => new Date(d.validFrom) > new Date(supplierDeliveryTermDays.validFrom));
        }

        return nextDeliveryTermDays;
    }

    private getDisableDateRangesForDaysFrom(formType: string) {
        let days: ISupplierDeliveryTermDays[] = [];

        if (formType === this.orderFormType) {
            days = this.sortDaysByValidFrom(this.supplierDeliveryTermOrderdays);
        } else if (formType === this.deliveryFormType) {
            days = this.sortDaysByValidFrom(this.supplierDeliveryTermDeliverdays);
        }

        const dateRanges: IMyDateRange[] = days.map((sdtd, idx, arr) => {
            const begin: IMyDate = this.coreService.convertToMyDate(moment(new Date(sdtd.validFrom)).toDate());
            const end: IMyDate = sdtd.validTill
                ? this.coreService.convertToMyDate(moment(new Date(sdtd.validTill)).toDate())
                : this.coreService.convertToMyDate(moment(new Date(sdtd.validFrom)).add(1, 'days').toDate());

            return {
                begin,
                end,
            } as IMyDateRange;
        });

        return dateRanges;
    }

    private getDateTillFormOptions(formType: string, supplierDeliveryTermDays: ISupplierDeliveryTermDays) {
        const dateTillOptions: IMyOptions = {
            dateRange: false,
            dateFormat: 'dd.mm.yyyy',
            appendSelectorToBody: true,
        };

        if (this.systemMethod === SystemMethod.NEW && !supplierDeliveryTermDays.validFrom) {
            // disableUntil: set initially to the day after tomorrow, b/c validFrom is from tomorrow on
            dateTillOptions.disableUntil = this.coreService.convertToMyDate(moment(new Date()).add(1, 'days').toDate());
        } else {
            // disableUntil: when EDIT, validTill can end today
            dateTillOptions.disableUntil = this.getDisableUntilDateForDaysTill(supplierDeliveryTermDays);
        }

        const disableSinceValue = this.getDisableSinceDateForDaysTill(supplierDeliveryTermDays, formType);
        if (!isNil(disableSinceValue)) {
            dateTillOptions.disableSince = disableSinceValue;
        }

        return dateTillOptions;
    }

    public checkSaveDeliveryDay() {
        if (!this.checkAllValidTillSet(this.deliveryFormType)) {
            this.showSetValidTillForOtherDaysHintModal(this.deliveryFormType);
            return;
        }

        this.saveDeliverydays();
    }

    public checkSaveOrderDay() {
        if (!this.checkAllValidTillSet(this.orderFormType)) {
            this.showSetValidTillForOtherDaysHintModal(this.orderFormType);
            return;
        }

        this.saveOrderday();
    }

    private checkAllValidTillSet(formType: string) {
        let days: ISupplierDeliveryTermDays[] = [];
        let form: UntypedFormGroup;

        if (formType === this.orderFormType) {
            days = this.sortDaysByValidFrom(this.supplierDeliveryTermOrderdays, 'desc');
            form = this.orderdaysModalForm;
        } else if (formType === this.deliveryFormType) {
            days = this.sortDaysByValidFrom(this.supplierDeliveryTermDeliverdays, 'desc');
            form = this.deliverydaysCustomerModalForm;
        }

        // skip the last one, it can be saved without validTill
        days.shift();
        // skip the one being edited
        if (this.systemMethod === SystemMethod.EDIT) {
            days = days.filter((sdtd) => sdtd.id !== form.get('id')?.value);
        }

        return !days.some((sdtd) => !sdtd.validTill);
    }

    private isLastDeliveryTermDays(formType: string, deliveryTermDaysId: number) {
        let days: ISupplierDeliveryTermDays[] = [];

        if (formType === this.orderFormType) {
            days = this.sortDaysByValidFrom(this.supplierDeliveryTermOrderdays, 'desc');
        } else if (formType === this.deliveryFormType) {
            days = this.sortDaysByValidFrom(this.supplierDeliveryTermDeliverdays, 'desc');
        }
        const lastDeliveryTermDays = days.shift();

        return deliveryTermDaysId === lastDeliveryTermDays.id;
    }

    showSetValidTillForOtherDaysHintModal(formType: string) {
        this.setValidTillHintModalVersion = formType;
        const options: NgbModalOptions = { centered: false, backdrop: 'static', size: 'lg' };
        this.modalService.openModal(this.setValidTillHintModal(), options);
    }

    private sortDeliveryDaysByDateFrom(days: IWeek[], order: string = 'asc'): IWeek[] {
        if (order === 'desc') {
            return orderBy(days, [(day) => new Date(day.datefrom)], ['desc']);
        }

        return orderBy(days, [(day) => new Date(day.datefrom)], ['asc']);
    }

    private sortOrderDaysByDateFrom(days: IOrderFrequency[], order: string = 'asc'): IOrderFrequency[] {
        if (order === 'desc') {
            return orderBy(days, [(day) => new Date(day.datefrom)], ['desc']);
        }

        return orderBy(days, [(day) => new Date(day.datefrom)], ['asc']);
    }

    private sortDaysByValidFrom(days: ISupplierDeliveryTermDays[], order: string = 'asc') {
        if (order === 'desc') {
            return orderBy(days, [(day) => new Date(day.validFrom)], ['desc']);
        }

        return orderBy(days, [(day) => new Date(day.validFrom)], ['asc']);
    }

    private getFavoriteSupplierCustomerAddress() {
        const favoriteAddresses = this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.filter((sCA) => sCA.isFavorite);

        return favoriteAddresses.shift();
    }

    private showSelectNewFavoriteAddressHintModal() {
        const options: NgbModalOptions = { centered: false, backdrop: 'static', size: 'lg' };
        this.modalService.openModal(this.selectNewFavoriteAddressHintModal(), options);
    }

    public closeModal() {
        this.modalService.closeAllModals();
    }

    private ensureFavoriteSupplCustAddressSet() {
        if (!!this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.length) {
            const newFavoriteSupplCustAddress = this.supplierService.supplierCustomerDetails.supplierCustomerAddresses[0];
            newFavoriteSupplCustAddress.isFavorite = true;

            this.getSaveSupplierCustomerAddressRequest(newFavoriteSupplCustAddress)
                .pipe(take(1))
                .subscribe(
                    (result) => {
                        this.supplierService.supplierCustomerDetails.supplierCustomerAddresses =
                            this.supplierService.supplierCustomerDetails.supplierCustomerAddresses.concat();
                        this.fillAddresses();

                        this.modalService.closeAllModals();
                        this.loadingOverlayService.stopLoading();
                    },
                    (err: IError) => {
                        this.utilityHelperService.handleComponentError(err);
                    },
                );
        }
    }
}
